const TEMPLATE = `
<section class="certificates-list-section fade-up">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6">
                <p class="section-label" data-animate-child>Професійне зростання</p>
            </div>
            <div class="col-lg-6" style="margin-bottom: 24px !important;">
                <h2 data-animate-child data-delay="200">
                    Актуальні курси та програми
                </h2>
                <p data-animate-child data-delay="600">
                    Отримайте актуальні знання з морфології, генетики та цифрової діагностики від провідних
                    фахівців BML.
                </p>
            </div>
        </div>


        <div data-section="courses-section" id="courses-section">


        </div>
        <a class="load-more-" href="#">Завантажити більше</a>


    </div>
</section>
`;

class BmlCoursesList extends HTMLElement {
    connectedCallback() { if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE; }
}
customElements.define('bml-courses-list', BmlCoursesList);
